//** List Api

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// Axios Imports
import { toast } from 'react-toastify';
import axios from '@src/service/axios';

export const getList = createAsyncThunk('listSlice/getList', async () => {
    try {
        let response = await axios.get('/list', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getListOption = createAsyncThunk('listSlice/getListOption', async () => {
    try {
        let response = await axios.get('/list/options', {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return Promise.resolve(response?.data?.data);
    } catch (err) {
        console.log('err', err);

        toast.error(err?.response?.data?.message || 'Something went wrong!');

        return Promise.reject(err);
    }
});

export const createList = createAsyncThunk('listSlice/createList', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/list', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'List added successfully.');

        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateList = createAsyncThunk('listSlice/updateList', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/list/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'List updated successfully.');
        await dispatch(getList());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateListStatus = createAsyncThunk('listSlice/updateListStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/list/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || ' Status updated successfully !');
        dispatch(getList());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const deleteList = createAsyncThunk('listSlice/deleteList', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/list/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'List deleted successfully.');
        await dispatch(getList());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const listSlice = createSlice({
    name: 'listSlice',
    initialState: {
        data: [],
        option: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getList.fulfilled, (state, action) => {
            state.data = action.payload;

            return;
        });
        builder.addCase(getListOption.fulfilled, (state, action) => {
            state.option = action.payload;

            return;
        });
    }
});

export default listSlice.reducer;
